import { render, staticRenderFns } from "./BmModal.vue?vue&type=template&id=c6cae2e2&scoped=true&"
import script from "./BmModal.vue?vue&type=script&lang=js&"
export * from "./BmModal.vue?vue&type=script&lang=js&"
import style0 from "./BmModal.vue?vue&type=style&index=0&id=c6cae2e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cae2e2",
  null
  
)

export default component.exports